var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header"},[_c('svg-icon',{staticClass:"icon",attrs:{"iconClass":"arrow-left"},on:{"click":_vm.handleBack}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }